// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.loginForm {
  width: 450px;
  height: fit-content;
  padding: 20px;
  margin-top: 50px;
  border-radius: 7px;
  background-color: #fff;
}
.loginForm .welcomeMessage {
  text-align: center;
  margin-bottom: 20px;
}
.loginForm .welcomeMessage h5 {
  color: var(--headerFont);
}
.loginForm .welcomeMessage p {
  color: var(--mainFont);
  margin: 5px 0;
  font-size: 14px;
}
.loginForm .form input {
  font-size: 12px;
  padding: 8px;
}
.loginForm .form input:focus {
  border: 1px solid #53ca85;
  box-shadow: var(--inputshadow) !important;
}
.loginForm .form button {
  display: block;
  position: relative;
  width: 100%;
  font-size: 18px;
  background-color: var(--headerFont);
  border: none;
}
.loginForm .form button svg {
  margin-right: 5px;
}
.loginForm .form button:hover {
  background-color: #0f7f3d;
  box-shadow: var(--inputshadow) !important;
}
.loginForm .form button:focus {
  background-color: #0f7f3d;
  box-shadow: var(--inputshadow) !important;
}
.loginForm .form p {
  color: red;
  margin-top: 10px;
  font-weight: bold;
  border-radius: 5px;
  -webkit-border-radius: 5px;
  -moz-border-radius: 5px;
  -ms-border-radius: 5px;
  -o-border-radius: 5px;
}
.loginForm .form .mb-3 {
  position: relative;
}
.loginForm .form .mb-3 i {
  position: absolute;
  left: 10px;
  top: 55%;
  cursor: pointer;
}
.loginForm .form .form-check-input:checked {
  background-color: var(--headerFont);
  border-color: var(--headerFont);
}
.loginForm .form .form-check-label {
  margin-left: 5px;
}
.loginForm .form .inputError,
.loginForm .form .inputError:focus {
  border: 1px solid rgba(255, 0, 0, 0.3294117647);
  box-shadow: 0px 0px 5px 0px red !important;
}

.dark .loginForm {
  background-color: var(--darkSecondColor);
  color: var(--darkFont);
}
.dark .loginForm p {
  color: var(--darkFont);
}
.dark .loginForm input {
  background-color: var(--darkMaincolor) !important;
}`, "",{"version":3,"sources":["webpack://./src/components/Auth/LoginForm/loginform.scss"],"names":[],"mappings":"AAAA;EACE,YAAA;EACA,mBAAA;EACA,aAAA;EACA,gBAAA;EACA,kBAAA;EACA,sBAAA;AACF;AAAE;EACE,kBAAA;EACA,mBAAA;AAEJ;AADI;EACE,wBAAA;AAGN;AADI;EACE,sBAAA;EACA,aAAA;EACA,eAAA;AAGN;AACI;EACE,eAAA;EACA,YAAA;AACN;AACI;EACE,yBAAA;EACA,yCAAA;AACN;AACI;EACE,cAAA;EACA,kBAAA;EACA,WAAA;EACA,eAAA;EACA,mCAAA;EACA,YAAA;AACN;AAAM;EACE,iBAAA;AAER;AACI;EACE,yBAAA;EACA,yCAAA;AACN;AACI;EACE,yBAAA;EACA,yCAAA;AACN;AACI;EACE,UAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,0BAAA;EACA,uBAAA;EACA,sBAAA;EACA,qBAAA;AACN;AACI;EACE,kBAAA;AACN;AAAM;EACE,kBAAA;EACA,UAAA;EACA,QAAA;EACA,eAAA;AAER;AACI;EACE,mCAAA;EACA,+BAAA;AACN;AACI;EACE,gBAAA;AACN;AACI;;EAEE,+CAAA;EACA,0CAAA;AACN;;AAIE;EACE,wCAAA;EACA,sBAAA;AADJ;AAEI;EACE,sBAAA;AAAN;AAEI;EACE,iDAAA;AAAN","sourcesContent":[".loginForm {\n  width: 450px;\n  height: fit-content;\n  padding: 20px;\n  margin-top: 50px;\n  border-radius: 7px;\n  background-color: #fff;\n  .welcomeMessage {\n    text-align: center;\n    margin-bottom: 20px;\n    h5 {\n      color: var(--headerFont);\n    }\n    p {\n      color: var(--mainFont);\n      margin: 5px 0;\n      font-size: 14px;\n    }\n  }\n  .form {\n    input {\n      font-size: 12px;\n      padding: 8px;\n    }\n    input:focus {\n      border: 1px solid #53ca85;\n      box-shadow: var(--inputshadow) !important ;\n    }\n    button {\n      display: block;\n      position: relative;\n      width: 100%;\n      font-size: 18px;\n      background-color: var(--headerFont);\n      border: none;\n      svg {\n        margin-right: 5px;\n      }\n    }\n    button:hover {\n      background-color: #0f7f3d;\n      box-shadow: var(--inputshadow) !important ;\n    }\n    button:focus {\n      background-color: #0f7f3d;\n      box-shadow: var(--inputshadow) !important ;\n    }\n    p {\n      color: red;\n      margin-top: 10px;\n      font-weight: bold;\n      border-radius: 5px;\n      -webkit-border-radius: 5px;\n      -moz-border-radius: 5px;\n      -ms-border-radius: 5px;\n      -o-border-radius: 5px;\n    }\n    .mb-3 {\n      position: relative;\n      i {\n        position: absolute;\n        left: 10px;\n        top: 55%;\n        cursor: pointer;\n      }\n    }\n    .form-check-input:checked {\n      background-color: var(--headerFont);\n      border-color: var(--headerFont);\n    }\n    .form-check-label {\n      margin-left: 5px;\n    }\n    .inputError,\n    .inputError:focus {\n      border: 1px solid #ff000054;\n      box-shadow: 0px 0px 5px 0px red !important ;\n    }\n  }\n}\n.dark {\n  .loginForm {\n    background-color: var(--darkSecondColor);\n    color: var(--darkFont);\n    p {\n      color: var(--darkFont);\n    }\n    input {\n      background-color: var(--darkMaincolor) !important;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
